<template>
  <nav class="bg-[#6105a1] w-full fixed top-0 z-50">
    <div class="lg:mx-44 mx-4 sm:mx-6 md:mx-8 lg:h-24 flex flex-wrap items-center justify-between p-3 sm:p-4">

      <!-- ARROW VOLTAR + LOGO -->
      <div class="flex items-center space-x-2 sm:space-x-4 min-w-0 flex-shrink-0">
        <!-- Seta Voltar -->
        <button
            v-if="$route.path !== '/home'"
            @click="goBack"
            class="text-white hover:text-[#EE9F12] transition flex-shrink-0"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 sm:h-7 sm:w-7" fill="none" viewBox="0 0 24 24"
               stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <a href="/home" class="flex items-center flex-shrink-0">
          <img :src="logo" class="h-12 sm:h-14 md:h-14" alt=" Logo"/>
        </a>
      </div>

      <!-- BOTÃO HAMBURGER -->
      <button
          @click="toggleNavbar"
          type="button"
          class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden focus:outline-none focus:ring-2 focus:ring-[#EE9F12] flex-shrink-0"
          aria-controls="navbar-default"
          aria-expanded="false"
      >
        <span class="sr-only">Open main menu</span>
        <svg
            v-if="!showMenu"
            class="w-7 h-7 sm:w-8 sm:h-8 text-[#EE9F12]"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 17 14"
        >
          <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M1 1h15M1 7h15M1 13h15"
          />
        </svg>
        <svg v-else class="w-7 h-7 sm:w-8 sm:h-8 text-[#EE9F12]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 17">
          <path fill="currentColor" d="M14.602 14.602c.586-.586.586-1.536 0-2.121l-3.713-3.713 3.713-3.713c.586-.586.586-1.536 0-2.121-.586-.586-1.536-.586-2.121 0l-3.713 3.713-3.713-3.713c-.586-.586-1.536-.586-2.121 0-.586.586-.586 1.536 0 2.121l3.713 3.713-3.713 3.713c-.586.586-.586 1.536 0 2.121.586.586 1.536.586 2.121 0l3.713-3.713 3.713 3.713c.586.586 1.536.586 2.121 0z"/>
        </svg>
      </button>

      <!-- MENU DESKTOP -->
      <div :class="showMenu ? 'block' : 'hidden'" class="w-full md:flex md:items-center md:w-auto md:flex-1 md:justify-end" id="navbar-default">
        <div class="md:flex md:items-center md:space-x-4 lg:space-x-6 xl:space-x-8">
          <ul class="font-medium flex md:items-center flex-col md:flex-row md:space-x-4 lg:space-x-6 xl:space-x-8 py-4 md:py-0 space-y-2 md:space-y-0">
            <li v-for="(item, index) in menuItems" :key="index">
              <router-link
                  :to="item.to"
                  :target="item.target || ''"
                  @click.native="item.section ? navigateToSection(item.section) : null; showMenu = false"
                  class="block text-white rounded hover:bg-[#EE9F12] py-2 px-3 md:py-1 md:px-2 md:hover:bg-transparent md:border-0 md:hover:text-[#EE9F12] text-base md:text-sm lg:text-base whitespace-nowrap transition-colors duration-200"
              >
                {{ item.label }}
              </router-link>
            </li>

            <!-- SELETOR DE IDIOMA -->
            <li class="md:ml-2">
              <select
                  class="bg-[#6105a1] py-2 md:py-1 text-lg md:text-base text-white border-none outline-none cursor-pointer hover:text-[#EE9F12] transition-colors duration-200"
                  @change="changeLanguage($event.target.value)"
                  :value="$route.path.startsWith('/en') ? 'en' : 'pt'"
              >
                <option value="pt">🇧🇷</option>
                <option value="en">🇺🇸</option>
              </select>
            </li>
          </ul>

          <!-- PESQUISA GLOBAL -->
          <div class="relative mt-4 md:mt-0 md:ml-4 lg:ml-6">
            <div class="flex items-center rounded-lg bg-[#500387] px-3 py-2 md:py-2">
              <input
                  v-model="searchQuery"
                  @keyup.enter="goToSearch"
                  type="text"
                  class="outline-none bg-[#500387] text-white w-full md:w-32 lg:w-40 xl:w-48 text-sm md:text-base placeholder-gray-300"
                  placeholder="Pesquisar"
              />
              <button @click="goToSearch" class="ml-2 text-[#EE9F12] hover:text-white transition-colors duration-200 flex-shrink-0">
                <svg class="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"
                     stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 21l-4.35-4.35"></path>
                  <circle cx="10" cy="10" r="6"></circle>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>

  <!-- Espaçamento para compensar navbar fixed -->
  <div class="h-16 sm:h-18 md:h-20 lg:h-24"></div>
</template>

<script>
import logo from "@/assets/logo.png";
import { useRouter } from "vue-router";

export default {
  name: "Navbar",
  props: {
    language: {
      type: String,
      default: 'pt'
    }
  },
  data() {
    return {
      showMenu: false,
      searchQuery: '',
      menuItems: [
        { label: 'Home', to: '/home', section: 'HomeSection' },
        { label: 'Jogos', to: '/home', section: 'gamesSection' },
        { label: 'Gamificação', to: '/gamificacao/home', target: '_blank' },
        { label: 'Quem somos', to: '/home', section: 'quemSomosSection' },
        { label: 'Contato', to: '/home', section: 'contatoSection' }
      ]
    };
  },
  computed: {
    logo() {
      return logo;
    }
  },
  methods: {
    toggleNavbar() {
      this.showMenu = !this.showMenu;
    },
    goBack() {
      this.$router.back();
    },
    navigateToSection(sectionId) {
      const currentPath = this.$route.path;
      if (currentPath !== '/home') {
        this.$router.push({ path: '/home', hash: `#${sectionId}` });
      } else {
        this.$scrollTo(`#${sectionId}`, 800, { offset: -200 });
      }
    },
    changeLanguage(language) {
      const currentPath = this.$route.fullPath;
      const isEnglish = currentPath.startsWith('/en');
      if (language === 'en' && !isEnglish) {
        const newPath = `/en${currentPath}`;
        this.$router.push(newPath);
      } else if (language === 'pt' && isEnglish) {
        const newPath = currentPath.replace(/^\/en/, '');
        this.$router.push(newPath);
      }
    },
    goToSearch() {
      if (this.searchQuery.trim().length > 0) {
        this.$router.push({ path: '/search', query: { q: this.searchQuery.trim() } });
        this.searchQuery = '';
        this.showMenu = false;
      }
    }
  }
};
</script>
